import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class Menu extends Component {
	render() {
		return (

			<div className="row menuGlobal">
				<div className="col-md-12 ocultarDesktop">
					<button className="btnMenuResponsivo" data-toggle="collapse" data-target="#menuResponsivo" aria-controls="menuResponsivo" aria-expanded="false" aria-label="Toggle navigation">
						Menu
					</button>
				</div>
				<div className="col-md-12 ">
					<nav className="navbar navbar-expand-md navbar-toggleable-md">
						<div className="navbar-collapse collapse" id="menuResponsivo">
							<ul className="nav navbar-nav">
								<li className="nav-item dropdown">
									<button id="conoceSIJE" className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" aria-haspopup="true" aria-expanded="false">Conoce el SIJE</button>
									<div className="dropdown-menu">
										<Link className="dropdown-item" to="./QueEsSIJE">¿Qué es el SIJE?</Link>
										<Link className="dropdown-item" to="./ComoOperaSIJE">¿Cómo opera el SIJE?</Link>
										<Link className="dropdown-item" to="./BaseDatos">Base de datos</Link>
										{/* <Link className="dropdown-item" to="./CatalogoIncidentes">Catálogo de incidentes</Link> */}
									</div>
								</li>
								{/* <li className="nav-item dropdown">
									<button id="acercaCasillas" className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" aria-haspopup="true" aria-expanded="false">Acerca de las casillas</button>
									<div className="dropdown-menu">
										<Link className="dropdown-item" to="./TiposCasilla">Tipos de casilla</Link>
										<Link className="dropdown-item" to="./Conformacion">Conformación</Link>
										<Link className="dropdown-item" to="./FuncionariosCasilla">Funcionarios de casilla</Link>
									</div>
								</li> */}
								<li>
									<Link id="FuncCasilla" className="nav-link" to="./FuncionariosCasilla">Funcionarios de casilla</Link>
								</li>
								<li>
									<Link id="jornadaElec" className="nav-link" to="./JornadaElectoral">Jornada Electoral</Link>
								</li>
								{/* <li className="nav-item dropdown">
									<button id="jornadaElec" className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" aria-haspopup="true" aria-expanded="false">Jornada Electoral</button>
									<div className="dropdown-menu">
									<Link className="dropdown-item" to="./EtapasJornada">Etapas de la Jornada</Link>
									<Link className="dropdown-item" to="./InstalacionCasillas">Instalación de casillas</Link>
									<Link className="dropdown-item" to="./Incidentes">Incidentes</Link>
									</div>
								</li> */}
								<li>
									<Link id="preguntasFrec" className="nav-link" to="./PreguntasFrecuentes">Preguntas frecuentes</Link>
								</li>
								<li>
									<Link id="Glosariolink" className="nav-link" to="./Glosario">Glosario</Link>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</div>
			
		)
	}
}

export default Menu;